export default class Search {
    constructor() {
        const element = document.querySelector(".js-search");

        if (element) {
            import(
                /* webpackChunkName: "Search" */ "../classes/Search"
            ).then(res => {
                const Search = res.default;
                this.createInstance(Search, element);
            });
        }
    }

    createInstance(Search, element) {
        return new Search(element);
    }
}
